<template>
    <header class="header-section navbar navbar-expand-lg" @mouseenter="isMouseOnHead" @mouseleave="isMouseOnHead" :style="headerTop">
		<div class="container">
			<div class="navbar-toggler">
				<button ref="menuBtn" :class="navContentVisible ? null : 'collapsed'" :aria-expanded="navContentVisible ? 'true' : 'false'" aria-controls="navbarSupportedContent" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" @click="navToggle">
					<div :class="['hamberger', { open: navContentVisible }]">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<!-- <span class="txt">menu</span> -->
				</button>
			</div>

			<div class="navbar-brand">
				<router-link to="/" @click="listItemOnclick">
					<img :src="require('@/assets/images/common/logo_new.png')" alt="logo">
				</router-link>
			</div>

			<div class="navbar-content">
				<div class="navbar-tool">
					<div class="icons">
						<div v-if="loggedIn" class="login_btn item">
							<router-link to="/order/list" @click="listItemOnclick">
								<BIconPersonCircle />
							</router-link>
						</div>
						<div v-else class="login_btn item">
							<router-link to="/member/login" @click="listItemOnclick">
								<BIconPerson />
							</router-link>
						</div>
						<div class="cart_btn item">
							<router-link to="/cart/step1" @click="listItemOnclick">
								<BIconCart3 />
								<span v-if="cartNum" id="cart_num">{{ cartNum }}</span>
							</router-link>
						</div>
					</div>
				</div>
				<b-collapse class="navbar-collapse" id="navbarSupportedContent" v-model="navContentVisible">
					<div class="navbar-search">
						<ValidationForm @submit="search">
							<div class="input-group">
								<Field v-slot="{ field }" name="query">
									<input v-bind="field" class="form-control" type="search" placeholder="搜尋商品名稱 ..." aria-label="Search" name="query">
								</Field>
								<button class="btn"><BIconSearch /></button>
							</div>
						</ValidationForm>
					</div>
					<ul class="navbar-nav me-auto mb-lg-0">
						<li v-if="greenGuide" class="nav-item dropdown" @mouseenter="goodNight" @mouseleave="goodMorning">
							<router-link to="" class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								綠色生活指南
							</router-link>
							<ul class="dropdown-menu" ref="greenGuide">
								<li @click="listItemOnclick('greenGuide')" v-for="(guide, guideIndex) in greenGuide" :key="guideIndex">
									<router-link class="dropdown-item" :to="`${guide.link}`">
										{{ guide.name }}
									</router-link>
								</li>
							</ul>
						</li>
						
						<li class="nav-item" @click="listItemOnclick">
							<router-link class="nav-link" to="/activity">最新活動</router-link>
						</li>

						<li v-if="classicCoffeeProducts" class="nav-item dropdown" @mouseenter="goodNight" @mouseleave="goodMorning">
							<router-link to="" class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								經典咖啡養護系列
							</router-link>
							<ul class="dropdown-menu" ref="classicCoffeeProducts">
								<li @click="listItemOnclick('classicCoffeeProducts')" v-for="(product, productIndex) in classicCoffeeProducts" :key="productIndex">
									<router-link class="dropdown-item" :to="`/product/${product.id}`">
										{{ product.name }}
									</router-link>
								</li>
							</ul>
						</li>

						<template v-if="categoriesArray">
							<li class="nav-item dropdown" v-for="(categoryItem, categoryIndex) in categoriesArray" :key="categoryIndex" @mouseenter="goodNight" @mouseleave="goodMorning">
								<router-link to="" class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
									{{ categoryItem.name }}
								</router-link>
								<ul class="dropdown-menu" ref="categoryUl">
									<li @click="listItemOnclick(categoryIndex)">
										<router-link class="dropdown-item" :to="`/category/${categoryItem.id}`">全系列</router-link>
									</li>

									<li v-for="(categoryList, categoryListIndex) in categoryItem.children" :key="categoryListIndex" @click="listItemOnclick(categoryIndex)">
										<router-link class="dropdown-item" :to="{ path: `/category/${categoryItem.id}`, hash: `#category_list_${categoryList.id}` }"  :ref="`#${categoryList.id}`">
											{{ categoryList.name }}
										</router-link>
									</li>
								</ul>
							</li>
						</template>
					</ul>
				</b-collapse>
			</div>
		</div>
	</header>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations, mapActions } = createNamespacedHelpers("headerStore");
export default {
	data() {
		return {
			classicCoffeeProducts: [
				{ id: 262, name: "咖啡因洗髮精400ml" },
				{ id: 296, name: "咖啡因護髮素250ml" },
				{ id: 477, name: "咖啡因麥拉寧養髮液50ml" },
				{ id: 476, name: "咖啡因麥拉寧養髮液100ml" },
				{ id: 301, name: "咖啡因養髮液50ml" },
				// { id: 439, name: "Recoffee護髮油100ml" },
				{ id: 418, name: "Recoffee菁萃修復髮膜100ml" },
			],
			greenGuide: [
				{link: "/page/Rainseason2025", name: "梅雨季的優雅對策"},
				{link: "/page/haircare2025", name: "花開髮舞喚醒沉睡髮絲"},
				{link: "/page/Sustainablebag", name:"綠色永續提袋計劃"},
				{link: "/page/newyear2501", name:"新年儀式 從頭開始"},
				{link: "/page/christmas2412", name:"冬季質感禮物精選"},
				{link: "/page/haircare2410", name:"換季髮絲呵護指南"},
				{link: "/page/scalprevitalizerpick", name:"挑選養髮液的關鍵要素"},
				{link: "/page/orightsummerplan", name:"夏日專屬5個健康生活方式"},
				{link: "/page/CoolSummerMustHaves", name:"夏日清爽6個良品推薦"},
				{link: "/page/momgift2404", name: "禮物挑選指南"},
			],
			headerWidth: null,
			pushHeaderPermit: true,
			navContentVisible: false,
			prevScrollpos: null,
			headerShown: true,
			app: undefined,
		}
	},
    async serverPrefetch() {
		await this.clearCategories();
		await this.getCategories(this.axios);
    },
	async mounted() {
		this.prevScrollpos = window.pageYOffset;
		this.app = document.querySelector("#app");
		await this.getCategories(this.axios);
		if (this.userStatePromise) {
			const { data: { login, num } } = await this.userStatePromise;
			this.$store.commit("headerStore/setLoggedIn", login);
			this.$store.commit("headerStore/setCartNum", num);
		}

		new ResizeObserver((headerEntry) => {
			this.headerWidth = headerEntry[0].contentRect.width;
		}).observe(this.$el, {
			box: "border-box",
		});

		window.addEventListener("scroll", (scrollEvent) => {
			this.pushHeader(scrollEvent);
		});
	},
	methods: {
		...mapActions([
			"getCategories",
			"clearCategories",
		]),
		...mapMutations([
			"setHeaderHeight",
		]),
		async isMouseOnHead(event) {
			switch (event.type) {
				case "mouseenter":
					this.pushHeaderPermit = false;
					break;

				case "mouseleave":
					this.pushHeaderPermit = true;
					break;

				default:
					break;
			}

			// for safari
			if (this.$route.name === "Category") {
				await this.$store.dispatch("categoriesProductsStore/getCategoriesList", {
					axios: this.axios,
					cid: this.$route.params.cid,
				});
				this.pushHeader(new Event("scroll"));
			}
		},
		pushHeader(scrollEvent) {
			if (this.pushHeaderPermit && !this.$store.state.isMobile || !this.navContentVisible && this.$store.state.isMobile) {
				let currentScrollPos = window.pageYOffset;
				if (this.prevScrollpos >= currentScrollPos || window.pageYOffset <= 0) {
					this.headerShown = true;
				} else {
					this.headerShown = false;
				}
				this.prevScrollpos = currentScrollPos;
			} else {
				scrollEvent.preventDefault();
			}
		},
		goodNight(event) {
			if (event) {
				event.target.querySelector(".dropdown-menu").style.display = this.$store.state.isMobile ? "" : "block";
			}
			this.app.classList.add("night");
			if (this.$store.state.isMobile) {
				document.body.classList.add("stop-scrolling");
			}
		},
		goodMorning() {
			if (!this.navContentVisible) {
				this.app.classList.remove("night");
				document.body.classList.remove("stop-scrolling");
			}
		},
		navToggle() {
			if (this.navContentVisible) {
				this.goodNight();
			} else {
				this.goodMorning();
			}
		},
		navClose() {
			if (this.navContentVisible) {
				this.navContentVisible = false;
				this.goodMorning();
			}
		},
		listItemOnclick(categoryKey) {
			if (!this.$store.state.isMobile) {
				switch (typeof(categoryKey)) {
					case "string":
						this.$refs[categoryKey].style.display = "none";
						break;

					case "number":
						this.$refs["categoryUl"][categoryKey].style.display = "none";
						break;

					default:
						break;
				}
			}
			this.navClose();
			this.goodMorning();
		},
		search({ query }) {
			if (query) {
				this.$router.push(`/search/${query}`);
				this.navClose();
			}
		},
	},
	computed: {
		...mapState([
			"headerHeight",
			"categoriesArray",
			"loggedIn",
			"cartNum",
			"userStatePromise",
		]),
		headerTop() {
			if (this.headerShown) {
				return {
					top: "0px"
				}
			} else {
				return {
					top: `-${this.$el.clientHeight}px`
				}
			}
		}
	},
	watch: {
		headerWidth(newWidth, oldWidth) {
			if (Math.abs(newWidth - oldWidth) > 15) {
				this.navClose();
				this.$refs.classicCoffeeProducts.style.display = "none";
			}
			if (this.$refs.categoryUl && this.$refs.categoryUl.length) {
				this.$refs.categoryUl.forEach(element => {
					element.style.display = "none";
				});
			}
			if (!this.navContentVisible) {
				this.setHeaderHeight(this.$el.clientHeight);
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.navbar {
	background-color: #ffffff;
	padding-bottom: 0;
	z-index: 1040;
	position: fixed;
	width: 100%;
	top: 0;
	transition: .4s;
	@media all and (min-width: 992px) {
		position: fixed;
	}
	.container {
		position: relative;
		@media all and (min-width: 992px) {
			display: flex;
			align-items: flex-end;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		.navbar-toggler {
			border: none;
			padding: 0;
			position: absolute;
			top: 13px;
			left: auto;

			button {
				display: inline-flex;
				align-items: center;
				border: none;
				letter-spacing: 0;
				padding: 0.3rem;
				background-color: transparent;
				.txt {
					font-size: 1.1rem;
					height: 20px;
				}
				.hamberger {
					display: inline-block;
					width: 30px;
					padding: 0.3rem;
					span {
						display: block;
						height: 2px;
						background-color: $brand-gray;
						margin-bottom: 4px;
						transition: 0.4s;
					}
					span:last-child {
						margin-bottom: 0;
					}
					&.open span {
						background-color: $brand-green;
					}
					&.open span:nth-child(1) {
						width: 24px;
						transform: rotate(-45deg) translate(-3px, 3px);
						margin-bottom: 0;
					}
					&.open span:nth-child(2) {
						opacity: 0;
					}
					&.open span:nth-child(3) {
						width: 24px;
						transform: rotate(45deg) translate(-3px, -3px);
					}
				}
			}
		}

		.navbar-brand {
			width: 100%;
			margin: 0;
			padding: 0;
			max-width: 100px;
			margin: auto;
			@media all and (min-width: 992px) {
				max-width: 140px;
				margin-left: 0;
				margin-right: 1rem;
				padding-top: 5px;
				padding-bottom: 5px;
			}
			@media all and (min-width: 1400px) {
				max-width: 155px;
			}
			a {
				display: block;
				padding: 1.1rem 0 1.1rem;
				img {
					width: 100%;
				}
			}
		}

		.navbar-content {
			width: 100%;
			max-height: 79vh;
			overflow-y: scroll;
			@media all and (min-width: 992px) {
				width: auto;
				overflow-y: inherit;
				max-height: none;
			}
		}

		.navbar-tool {
			position: absolute;
			top: 13px;
			right: 1rem;
			z-index: 5;
			@media all and (min-width: 992px) {
				top: 10px;
			}
			.icons {
				display: inline-flex;
				.item {
					a {
						color: $brand-gray;
						padding: 0.5rem 0.6rem;
						display: inline-block;
						text-decoration: none;
						svg {
							font-size: 1.6rem;
							display: flex;
							transition: all 0.1s ease-in;
							&:hover {
								color: $brand-green;
							}
						}
					}
					&.login_btn svg {
						font-size: 1.7rem;
					}
					&.cart_btn {
						position: relative;
						#cart_num {
							font-size: 12px;
							font-family: sans-serif;
							font-weight: 500;
							color: #fff;
							background-color: #8dc21f;
							line-height: 21px;
							width: 20px;
							height: 20px;
							display: inline-block;
							text-align: center;
							border-radius: 50%;
							position: absolute;
							top: 0%;
							left: 100%;
							margin-left: -20px;
						}
					}
				}
			}
		}

		.navbar-collapse {
			transition: .4s;
			max-height: 0px;
			&.show {
				padding: 0.5rem 1.5rem;
				max-height: 1000px;
			}
			@media all and (min-width: 992px) {
				padding: 0;
				max-height: fit-content;
			}
			.navbar-nav {
				@media all and (min-width: 992px) {
					width: 100%;
				}
			}
			.nav-item {
				border-bottom: 1px solid $color-black-10;
				@media all and (min-width: 992px) {
					border-bottom: none;
				}
			}
			.nav-item:hover .dropdown-menu {
				visibility:visible;
				margin-top: 0;
			}
			.nav-link {
				color: $brand-gray;
				font-weight: $family-medium;
				letter-spacing: 1px;
				padding: 0.7rem 0;
				@media all and (min-width: 992px) {
					padding: 0.7rem 0.7rem;
				}
				@media all and (min-width: 1200px) {
					padding: 0.7rem 1rem;
				}
				&:hover {
					color: $brand-green;
				}
			}
			//   .nav-link.show {
			//     color: $brand-green;
			//   }
			.dropdown-toggle::after {
				border: none;
				display: inline-block;
				width: 1rem;
				height: 1rem;
				background: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23677788' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E")
				no-repeat right center/1rem 1rem;
				content: "";
				margin-left: 0;
				transition: all 0.3s ease-in;
				vertical-align: inherit;
			}
			.dropdown-menu {
				border: none;
				border-top: 2px solid #8dc220;
				border-radius: inherit;
				padding-bottom: 1.3rem;

				@media all and (min-width: 992px) {
					min-width: 200px;
					border-top: 3px solid #8dc220;
					border-bottom-right-radius: 4px;
					border-bottom-left-radius: 4px;
					box-shadow: 0 12px 15px rgba(0, 0, 0, 0.2);
					padding-top: 0.7rem;
					padding-bottom: 1rem;
					transition: all 0.2s ease-in;
					visibility: hidden;
					overflow: hidden;
					display: block;
					margin-top: 15px;
					//   &.show {
					//     visibility: visible;
					//     margin-top: 0;
					//   }
				}
			}
			.dropdown-item {
				color: $brand-gray;
				font-size: 0.95rem;
				padding: 0.4rem 1rem;

				&:hover {
					color: $brand-green;
					background-color: transparent;
				}
				@media all and (min-width: 992px) {
					padding: 0.4rem 1.5rem;
				}
			}
		}
		.navbar-collapse.collapse:not(.show) {
			display: block;
		}

		.navbar-search {
			margin-bottom: 0.5rem;
			@media all and (min-width: 992px) {
				position: absolute;
				top: 13px;
				right: 115px;
				margin-bottom: 0;
				width: 250px;
			}

			input {
				font-size: 0.85rem;
				letter-spacing: 2px;
				border-radius: 20px;
				border: none;
				// background-color: $color-black-10;
				border: 1px solid $color-black-10;
				padding-left: 1.5rem;
				padding-top: 0.3rem;
				padding-bottom: 0.3rem;
			}
			button {
				background-color: $color-black-10;
				border-top-right-radius: 20px;
				border-bottom-right-radius: 20px;
				font-size: 0.9rem;
				&:hover {
					background-color: $brand-gray;
					color: #fff;
				}
			}
		}
	}
}
</style>